import {
  GET_ALL,
  GET_ALL_FAILURE,
  GET_ALL_SUCCESS,
  ADD,
  ADD_FAILURE,
  ADD_SUCCESS,
  DELETE,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  EDIT,
  EDIT_FAILURE,
  EDIT_SUCCESS,
  GET,
  GET_FAILURE,
  GET_SUCCESS,
} from "./actionTypes";

//actions types for CustomPlan

export const getAllCustomPlans = (payload) => {
  return {
    type: GET_ALL,
    payload: payload,
  };
};
export const getAllCustomPlansSuccess = (payload) => {
  return {
    type: GET_ALL_SUCCESS,
    payload: payload,
  };
};

export const getAllCustomPlansFailure = (error) => {
  return {
    type: GET_ALL_FAILURE,
    payload: error,
  };
};

export const addCustomPlan = (payload) => {
  return {
    type: ADD,
    payload: payload,
  };
};
export const addCustomPlanSuccess = (payload) => {
  return {
    type: ADD_SUCCESS,
    payload: payload,
  };
};

export const addCustomPlanFailure = (error) => {
  return {
    type: ADD_FAILURE,
    payload: error,
  };
};

export const getCustomPlan = (payload) => {
  return {
    type: GET,
    payload: payload,
  };
};
export const getCustomPlanSuccess = (payload) => {
  return {
    type: GET_SUCCESS,
    payload: payload,
  };
};

export const getCustomPlanFailure = (error) => {
  return {
    type: GET_FAILURE,
    payload: error,
  };
};

export const editCustomPlan = (payload) => {
  return {
    type: EDIT,
    payload: payload,
  };
};
export const editCustomPlanSuccess = (payload) => {
  return {
    type: EDIT_SUCCESS,
    payload: payload,
  };
};

export const editCustomPlanFailure = (error) => {
  return {
    type: EDIT_FAILURE,
    payload: error,
  };
};

export const deleteCustomPlan = (payload) => {
  return {
    type: DELETE,
    payload: payload,
  };
};

export const deleteCustomPlanSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload: payload,
  };
};

export const deleteCustomPlanFailure = (error) => {
  return {
    type: DELETE_FAILURE,
    payload: error,
  };
};
